import styled from 'styled-components';

/*
 * Botoes locais da tela de erro. Nao reaproveitam ButtonSuccess/ButtonClose porque
 * aqueles sao compartilhados com a tela de sucesso (fundo verde) e com o PIX (fundo
 * branco) — a cor que resolve o contraste aqui quebraria os outros dois contextos.
 * Contrastes sobre o card #e73f5d: primario branco 3.99:1 (componente, min 3:1),
 * tinta #a81f36 sobre branco 7.2:1 (AAA), secundario com scrim 5.59:1 (AA).
 */
const actionBase = `
	width: 100% !important;
	min-height: 48px !important;
	padding: 12px 20px !important;
	border-radius: 8px !important;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
	gap: 8px !important;
	cursor: pointer !important;
	font-weight: 700 !important;
	line-height: 1.2 !important;
	transition: background-color 160ms ease-out, box-shadow 160ms ease-out, transform 120ms ease-out !important;

	&:focus-visible {
		outline: 3px solid var(--ticto-white) !important;
		outline-offset: 2px !important;
	}

	&:active {
		transform: translateY(1px) !important;
	}

	@media (prefers-reduced-motion: reduce) {
		transition: none !important;

		&:active {
			transform: none !important;
		}
	}
`;

export const ErrorActionPrimary = styled.button`
	${actionBase}
	font-size: 16px !important;
	border: 0 !important;
	background: var(--ticto-white) !important;
	color: var(--ticto-error-ink) !important;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.16) !important;

	&:hover:not([disabled]) {
		background: var(--ticto-error-tint) !important;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.22) !important;
	}

	&[disabled] {
		cursor: not-allowed !important;
		background: var(--ticto-error-scrim) !important;
		color: var(--ticto-white) !important;
		box-shadow: none !important;
	}
`;

export const ErrorActionSecondary = styled.button`
	${actionBase}
	font-size: 15px !important;
	letter-spacing: 0.06em !important;
	background: var(--ticto-error-scrim) !important;
	color: var(--ticto-white) !important;
	border: 1px solid var(--ticto-error-hairline) !important;

	&:hover {
		background: var(--ticto-error-scrim-strong) !important;
	}

	/* Sem erro de pagamento o primario nao renderiza: a unica acao vira a solida. */
	&:only-child {
		background: var(--ticto-white) !important;
		color: var(--ticto-error-ink) !important;
		border-color: transparent !important;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.16) !important;

		&:hover {
			background: var(--ticto-error-tint) !important;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.22) !important;
		}
	}
`;

export const ErrorMessage = styled.div`
	padding: 16px !important;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;

	.ticto-error-message {
		--ticto-error-ink: #a81f36;
		--ticto-error-tint: #f6dbe2;
		--ticto-error-scrim: rgba(0, 0, 0, 0.18);
		--ticto-error-scrim-strong: rgba(0, 0, 0, 0.28);
		--ticto-error-hairline: rgba(255, 255, 255, 0.45);

		display: flex !important;
		flex-direction: column !important;
		gap: 16px !important;
		align-items: center !important;
		justify-content: center !important;
		width: 100% !important;
		margin: 0 auto !important;
		border-radius: 08px !important;
		padding: 32px !important;
		background: var(--ticto-red) !important;

		* {
			color: white;
		}

		h1 {
			text-align: center !important;
			color: var(--ticto-white) !important;
			font-size: 24px !important;
			white-space: pre-line !important;
			margin: 0 !important;
		}

		p {
			display: flex !important;
			align-items: center !important;
			justify-content: center !important;
			gap: 16px !important;
			margin: 0 !important;

			* {
				max-width: fit-content;
			}

			> svg {
				max-width: fit-content;
				height: fit-content;
				margin: 0 !important;
			}
		}

		> svg {
			width: 100px !important;
			height: 100px !important;
			color: var(--ticto-white) !important;
		}

		.actions {
			display: flex;
			flex-direction: column;
			gap: 12px;
			align-items: center;
			width: 100%;
			padding-top: 12px;
		}
	}
`;
